export default function VoiceWaveform({ active = false, color = "hsl(var(--primary))" }) {
  return (
    <div className="flex items-center gap-1 h-6">
      {[0, 1, 2, 3, 4].map((i) => (
        <span
          key={i}
          className={`w-1 rounded-full ${active ? "wave-bar" : ""}`}
          style={{
            background: color,
            height: active ? "100%" : "30%",
            animationDelay: `${i * 0.12}s`,
          }}
        />
      ))}
    </div>
  );
}
